import HttpException from './HttpException';

export default class ServerErrorHttpException extends HttpException {
	name = 'ServerErrorHttpException';

	constructor(response: Response, protected responseBody?: any) {
		super(response, responseBody?.message ?? 'Exceptions.services.http.server_error');
	}

	getResponseBody() {
		return this.responseBody;
	}
}
